import { FileText, Users, Shield, ArrowRight } from 'lucide-react'

interface LandingPageProps {
  onShowLogin: () => void
  onShowSignup: () => void
}

export default function LandingPage({ onShowLogin, onShowSignup }: LandingPageProps) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Header */}
      <header className="px-6 py-4">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <FileText className="h-8 w-8 text-blue-600" />
            <span className="text-2xl font-bold text-gray-900">IEP Scout</span>
          </div>
          <div className="space-x-4">
            <button
              onClick={onShowLogin}
              className="px-4 py-2 text-blue-600 hover:text-blue-700 font-medium"
            >
              Log In
            </button>
            <button
              onClick={onShowSignup}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
            >
              Sign Up
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <main className="px-6 py-20">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Your Child's Educational
            <span className="text-blue-600"> Advocate</span>
          </h1>
          <p className="text-xl text-gray-600 mb-12 max-w-3xl mx-auto">
            Organize, analyze, and understand your child's IEP documents with AI-powered insights. 
            Keep track of goals, services, and progress all in one place.
          </p>
          
          <div className="space-x-6">
            <button
              onClick={onShowSignup}
              className="px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-lg hover:bg-blue-700 inline-flex items-center space-x-2"
            >
              <span>Get Started Free</span>
              <ArrowRight className="h-5 w-5" />
            </button>
            <button
              onClick={onShowLogin}
              className="px-8 py-4 border-2 border-gray-300 text-gray-700 text-lg font-semibold rounded-lg hover:border-gray-400 inline-flex items-center space-x-2"
            >
              <span>Log In</span>
            </button>
          </div>
        </div>

        {/* Features */}
        <div className="max-w-7xl mx-auto mt-24">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <FileText className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Smart Document Analysis</h3>
              <p className="text-gray-600">
                Upload your IEP documents and get AI-powered analysis of goals, services, and accommodations.
              </p>
            </div>
            
            <div className="text-center p-8">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <Users className="h-8 w-8 text-green-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Student Management</h3>
              <p className="text-gray-600">
                Organize documents by student and track their educational journey over time.
              </p>
            </div>
            
            <div className="text-center p-8">
              <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <Shield className="h-8 w-8 text-purple-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Secure & Private</h3>
              <p className="text-gray-600">
                Your family's educational data is encrypted and private. Only you have access to your documents.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}